import React from "react";
import { IPanelProps, Panel } from "core/decorators/Panel";
import ArticleDetailsPanelConfig from "./config/ArticleDetailsPanelConfig";
import constants from "./constants";
import { FragmentLayout } from "../../core/components/FragmentLayout";
import * as articleFragments from "./article/fragments";
import { Article } from "./article/entities";
import Query from "core/api/QueryComponent";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";

interface articleState {
	navbarTabID: string;
}

@Panel({
	id: "knowledgebase-article-details",
	configClass: ArticleDetailsPanelConfig,
	pageParams: true,
})
class ArticleDeatislPanel extends React.Component<
	IPanelProps<ArticleDetailsPanelConfig>,
	articleState
> {
	constructor(props) {
		super(props);
		this.state = {
			navbarTabID: "article",
		};
	}
	handleTabChange = (navbarTabID: any) => {
		this.setState({ navbarTabID: navbarTabID });
	};

	public render() {
		const { config, pageParams } = this.props;
		const articleId = pageParams[constants.PARAM_ARTICLE_ID];
		const categoryId = pageParams[constants.PARAM_CATEGORY_ID];
		const knowledgeBaseId = pageParams[constants.PARAM_KB_ID];
		const params = {};
		if (articleId) {
			params["id"] = articleId;
		}

		return (
			<Query.One entity={Article} args={params}>
				{(args) => {
					if (args.loading) {
						return <Loading />;
					}

					if (!args.data) {
						return (
							<NonIdealState
								title="Article Not Found"
								description=""
							/>
						);
					}

					return (
						<FragmentLayout
							layout={config.mainLayout}
							fragments={{ ...articleFragments }}
							props={{
								config: config,
								article: args.data,
								categoryRefId: categoryId,
							}}
						/>
					);
				}}
			</Query.One>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/articleDetails/ArticleDetails.panel.tsx